import { createPortal } from 'react-dom'
import { JSX } from 'react'
import { AnimatePresence } from 'framer-motion'

import * as Styled from './styled'

interface IPositionOptions {
  width: number
  left: number
  verticalPosition: number
  verticalAnimationPosition: number
  availableHeight: string
}

interface IProps {
  isOpen: boolean
  content: JSX.Element
  setRef: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>
  positionOptions: IPositionOptions
  overlayClassName?: string
}

export const DropdownOverlay: React.FC<IProps> = props => {
  const { isOpen, content, setRef, positionOptions, overlayClassName } = props
  const {
    width,
    left,
    verticalPosition,
    verticalAnimationPosition,
    availableHeight
  } = positionOptions

  return createPortal(
    <AnimatePresence initial={false}>
      {isOpen && (
        <Styled.DropdownOverlayWrapper
          ref={setRef}
          initial={{ y: 0, opacity: 0 }}
          animate={{ y: verticalAnimationPosition, opacity: 1 }}
          exit={{ y: 0, opacity: 0 }}
          transition={{
            ease: 'linear',
            duration: 0.2
          }}
          width={width}
          left={left}
          top={verticalPosition}
          height={availableHeight}
          className={overlayClassName}
        >
          {content}
        </Styled.DropdownOverlayWrapper>
      )}
    </AnimatePresence>,
    document.getElementsByTagName('body')[0]
  )
}
